goog.provide('yext.location.DateTimeModel');
goog.provide('yext.location.DateTime');

goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.time');
goog.require('yext.location.helpers');

/**
 * Model for the date time field
 *
 * @param {string} date string representing the date
 * @param {string} time string representing the time
 * @param {boolean} True if the field is indeterminate
 *
 * @constructor
 * @author Vincent Vuong (vvuong@yext.com)
 */
yext.location.DateTimeModel = function(date, time, indeterminate) {
  this.date = date;
  this.time = time;
  this.indeterminate = indeterminate;
};

/**
 * Return true if the date time is updated
 *
 * @param {!Object} update The updated date time
 * @return {boolean} True if the data gets updated
 */
yext.location.DateTimeModel.prototype.update = function(update) {
  var changed = false;

  if (yext.isString(update.date) && update.date != this.date) {
    changed = true;
    this.date = update.date;
  }
  if (yext.isString(update.time) && update.time != this.time) {
    changed = true;
    this.time = update.time;
  }
  if (yext.isBoolean(update.indeterminate) && this.indeterminate != update.indeterminate) {
    this.indeterminate = update.indeterminate;
    changed = true;
  }

  if (changed) {
    this.message('updated');
  }
};

/**
 * Data keyed on strings for export
 *
 * @return {!Object} Model properties keyed with strings
 */
yext.location.DateTimeModel.prototype.getDataForExport = function() {
  return {
    'date': this.date,
    'time': this.time,
  };
};

/**
 * Get a copy of the date time data
 *
 * @return {!Object} Model properties
 */
yext.location.DateTimeModel.prototype.copy = function() {
  return {
    date: this.date,
    time: this.time,
    indeterminate: this.indeterminate,
  };
};

/**
 * Check if the field is empty
 *
 * @return boolean True if field is empty
 */
yext.location.DateTimeModel.prototype.isEmpty = function() {
  return this.date == '' && this.time == '' && !this.indeterminate;
};

/**
 * Trigger a message on the DateTimeModel
 *
 * @param {string} message Message to trigger
 */
yext.location.DateTimeModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.DateTime = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = this.$ctx.find('.js-field-value');
  this.$dateTime = $ctx.find('.js-date-time-row');
  this.$dateField = this.$dateTime.find('.js-date-input');
  this.$timeField = this.$dateTime.find('.js-time-input');
  this.$indeterminateMsg = $ctx.find('.js-indeterminate-message');

  this.timestamp = this.$ctx.data('timestamp');

  this.parseDataFromDOM();
  this.storeValue();
  this.setFieldValue();
  this.initDatepicker();
  this.initTimepicker();
  this.bindTimes();
  this.bindResetAll();
  this.bindUpdates();
};

/**
 * Bind the reset link in bulk edit mode
 */
yext.location.DateTime.prototype.bindResetAll = function() {
  var self = this;

  this.$ctx.find('.js-reset-all-date-time').click(function() {
    self.model.update({
      date: '',
      time: '',
      indeterminate: false,
    });
  });
};

/**
 * Parse the initial data from the DOM
 */
yext.location.DateTime.prototype.parseDataFromDOM = function() {
  var date = this.$dateField.val();
  var time = this.$timeField.val();
  var indeterminate = this.$ctx.data('indeterminate');
  this.model = new yext.location.DateTimeModel(date, time, indeterminate);
};

/**
 * Store the state for use in reset
 */
yext.location.DateTime.prototype.storeValue = function() {
  this.storedModel = this.model.copy();
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.location.DateTime.prototype.setFieldValue = function() {
  this.$fieldValue.val(this.getJSONData());
};

/**
 * Initialize the datepicker for the initial date
 */
yext.location.DateTime.prototype.initDatepicker = function() {
  var self = this;
  yext.time.newDatepicker(this.$dateField, function(date) {
    var options = {month: '2-digit', day: '2-digit', year: 'numeric'};
    self.model.update({
      date: date ? date.toLocaleDateString(window.currentLanguageFallbacks, options).replace(/[ \/\.\-]+/g, '/') : '',
      indeterminate: false,
    });
  });
};

/**
 * Initialize the timepicker for time
 */
yext.location.DateTime.prototype.initTimepicker = function() {
  this.$timeField.timepicker();
};

/**
 * Bind the date time inputs
 */
yext.location.DateTime.prototype.bindTimes = function() {
  var self = this;

  this.$timeField.inputchange(function() {
    self.model.update({
      time: $(this).val(),
      indeterminate: false,
    });
  });
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.DateTime.prototype.bindUpdates = function() {
  var self = this;

  $(this.model).on('updated', function() {
    self.render();
    self.setFieldValue();
    self.message('updated');
  });
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} message Message to trigger
 */
yext.location.DateTime.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the field to a stored state
 */
yext.location.DateTime.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the model data
 *
 * @param {!Object} field Field data
 */
yext.location.DateTime.prototype.set = function(field) {
  if (field.timestamp) {
    this.timestamp = field.timestamp;
  }
  this.model.update(field);
};

/**
 * Render the current state of the model
 */
yext.location.DateTime.prototype.render = function() {
  this.$indeterminateMsg.toggle(this.model.indeterminate);
  this.$dateTime.toggle(!this.model.indeterminate);

  if (this.$dateField.val() != this.model.date) {
    this.$dateField.val(this.model.date);
  }
  if (this.$timeField.val() != this.model.time) {
    this.$timeField.val(this.model.time);
  }
};

/**
 * Check if the field is empty
 *
 * @return boolean True if field is empty
 */
yext.location.DateTime.prototype.isEmpty = function() {
  return this.model.isEmpty();
};

/**
 * Get the display value for the field
 *
 * @return {string} html string
 */
yext.location.DateTime.prototype.getDisplayValue = function() {
  if (this.model.indeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    return this.model.date + ' ' + yext.msg('at') + ' ' + this.model.time + ' <span class="local-time-label">' + yext.msg('(Local Time)') + '</span>';
  }
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.DateTime.prototype.getJSONData = function() {
  var data = this.model.getDataForExport();
  data['timestamp'] = this.timestamp;
  return yext.JSON.stringify(data);
};
